const SENSITIVE_KEY_PATTERN =
  /password|authorization|token|api[_-]?key|secret|credential/i;

const SENSITIVE_HEADER_PATTERN = /^(authorization|x-api-key|cookie)$/i;

const SENSITIVE_VALUE_PATTERN = /^(Basic|Bearer|Token)\s+/i;

const MAX_SCRUB_DEPTH = 10;

function scrubValue(value: unknown, depth = 0): unknown {
  if (depth > MAX_SCRUB_DEPTH || value == null) {
    return value;
  }

  if (typeof value === 'string') {
    return SENSITIVE_VALUE_PATTERN.test(value) ? '[Filtered]' : value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => scrubValue(item, depth + 1));
  }

  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, nested]) => [
        key,
        SENSITIVE_KEY_PATTERN.test(key)
          ? '[Filtered]'
          : scrubValue(nested, depth + 1),
      ])
    );
  }

  return value;
}

export function scrubSensitiveData<T>(value: T): T {
  return scrubValue(value) as T;
}

export function scrubBreadcrumb<T extends { data?: Record<string, unknown> }>(
  breadcrumb: T
): T {
  if (!breadcrumb.data) {
    return breadcrumb;
  }

  const data = { ...breadcrumb.data };

  for (const [key, nested] of Object.entries(data)) {
    if (SENSITIVE_HEADER_PATTERN.test(key)) {
      data[key] = '[Filtered]';
      continue;
    }

    data[key] = scrubValue(nested);
  }

  return { ...breadcrumb, data };
}
